import { memo, ReactElement } from 'react';
import { DateTime } from 'luxon';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Box, styled, Typography } from '@mui/material';

import TimerIcon from '@mui/icons-material/Timer';

export interface SessionTimeProps {
  sessionStartedAt: DateTime;
  remainingTime?: string | null;
}

export const SessionTime = memo(function SessionTime({
  sessionStartedAt,
  remainingTime,
}: SessionTimeProps): ReactElement {
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='space-between'
      width='calc(100% / 1.75)'
    >
      <StyledContainer>
        <AccessTimeFilledIcon />
        <Typography variant='body1' color='textSecondary' sx={{ fontFamily: 'monospace' }}>
          {sessionStartedAt.toLocaleString(DateTime.TIME_24_SIMPLE)}
        </Typography>
      </StyledContainer>
      <StyledContainer>
        <TimerIcon />
        <Typography variant='body1' color='textSecondary' sx={{ fontFamily: 'monospace' }}>
          {remainingTime}
        </Typography>
      </StyledContainer>
    </Box>
  );
});

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
